import PropTypes from 'prop-types';

export const DaysOfWeek = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
};

export const DaysOfWeekPropTypes = PropTypes.shape({
  Monday: PropTypes.string.isRequired,
  Tuesday: PropTypes.string.isRequired,
  Wednesday: PropTypes.string.isRequired,
  Thursday: PropTypes.string.isRequired,
  Friday: PropTypes.string.isRequired,
  Saturday: PropTypes.string.isRequired,
  Sunday: PropTypes.string.isRequired,
});
